<template>
  <mymodal
    ref="theModal"
    :need-header="true"
    :need-footer="false"
    :size="'medium'"
  >
    <div slot="title">{{ getTitleText }}</div>
    <div slot="body">
      <div v-if="item">
        <loading
          v-if="list_provinces == null"
          class="mt10 text-center"
          :text="'Please wait' | translate"
        ></loading>
        <form
          class="land-form"
          v-if="list_provinces != null"
          v-on:submit.prevent="submitForm"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="mt20">{{ "Title" | translate }}</label>
                <input
                  v-model="item.title"
                  required
                  ref="title"
                  :placeholder="'Title' | translate"
                  class="form-control"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="mt20">{{ "Area" | translate }} (m2)</label>
                <input
                  required
                  type="number"
                  :placeholder="'Area' | translate"
                  v-model="item.area"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="mt20">{{ "Residental" | translate }} (m2)</label>
                <input
                  required
                  type="number"
                  :placeholder="'Residental' | translate"
                  min="0"
                  v-model="item.residental_area"
                  class="form-control"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="mt20">{{ "Description" | translate }}</label>
                <wysiwyg required v-model="item.description" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="mt20">{{ "Status" | translate }}</label>
                <select v-model="item.status" class="form-control">
                  <option value="1">{{ "Enabled" | translate }}</option>
                  <option value="0">{{ "Disabled" | translate }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="mt20">{{ "Purporse" | translate }}</label>
                <select
                  class="form-control"
                  v-model="item.type_id"
                  @change="onSelectType"
                  required
                >
                  <option
                    v-for="item in list_types"
                    :value="item.id"
                    :key="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="form-group"
                v-if="item.type_id != null && lease_id != item.type_id"
              >
                <label class="mt20">{{ "Price" | translate }}</label>
                <input
                  required
                  type="number"
                  min="0"
                  :max="max_price"
                  :placeholder="'Price' | translate"
                  class="form-control"
                  v-model="item.price"
                />
                <small>{{priceFormat}}</small>
              </div>
            </div>
          </div>

          <selectlocation
            v-if="item"
            :province="item.province_id"
            :district="item.district_id"
            :commune="item.commune_id"
            :p_location="item.location"
            @updateLocation="updateLocation"
          ></selectlocation>

          <!-- begin edit -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="mt20">{{ "Screet" | translate }}</label>
                <select v-model="item.street_type" class="form-control">
                  <option value="0">{{ showStreet(0) }}</option>
                  <option value="1">{{ showStreet(1) }}</option>
                  <option value="2">{{ showStreet(2) }}</option>
                  <option value="3">{{ showStreet(3) }}</option>
                  <option value="4">{{ showStreet(4) }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="mt20">{{ "Paper" | translate }}</label>
                <select v-model="item.certificate_type" class="form-control">
                  <option value="0">{{ showCertificate(0) }}</option>
                  <option value="1">{{ showCertificate(1) }}</option>
                  <option value="2">{{ showCertificate(2) }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row mt20">
            <div class="col-md-12">
              <p>
                <strong>{{ "Resources" | translate }}</strong>
              </p>
              <div class="checkbox">
                <span>
                  <label>
                    <input type="checkbox" v-model="item.resource_electric" />
                    {{ "Electric" | translate }}
                  </label> </span
                >&nbsp;&nbsp;&nbsp;

                <span>
                  <label>
                    <input type="checkbox" v-model="item.resource_water" />
                    {{ "Water" | translate }}
                  </label>
                </span>
                <!--
                            <span>
                                <label>
                                    <input type="checkbox" v-model="item.resource_transport" />
                                    {{'Transport'|translate}}
                                </label>
                            </span>
                            -->
              </div>
            </div>

            <div class="col-md-12">
              <p>
                <strong>{{ "Attached images" | translate }}</strong>
              </p>
              <div class="insert-gallery">
                <input
                  type="file"
                  id="file-upload"
                  ref="file"
                  v-on:change="handleFileUpload()"
                  style="display: none"
                />
                <a
                  class="btn btn-primary btn-sm"
                  :disabled="uploadingPhoto"
                  v-on:click="triggerFile"
                >
                  <i v-if="!uploadingPhoto" class="fa fa-plus"></i>
                  <i v-if="uploadingPhoto" class="fas fa-spinner fa-spin"></i>
                  {{ "Select files to upload" | translate }}
                </a>
              </div>
              <div class="gallery">
                <p v-if="editPhotos.length == 0">
                  {{ "There is no photo" | translate }}
                </p>
                <div v-if="editPhotos.length > 0">
                  <div
                    v-for="photo in editPhotos"
                    :key="photo.id"
                    class="gallery-item"
                  >
                    <img :src="photo.url_thumb" class="thumb" />
                    <a v-on:click="removePhoto(photo)" class="btn btn-danger">
                      <i class="fas fa-times"></i>
                      {{ "Remove" | translate }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>
            <button
              class="btn btn-success mt20"
              type="submit"
              :disabled="working"
            >
              <span v-if="item.id">{{ "Update" | translate }}</span>
              <span v-if="!item.id">{{ "Add" | translate }}</span>
            </button>
          </p>
        </form>
      </div>
    </div>
  </mymodal>
</template>

<script>
import mymodal from "@/components/elements/Modal";
import Utils from "@/helpers/utils";
import Loading from "@/components/elements/Loading";
import selectlocation from "@/components/elements/SelectLocation";
//import GoogleAutocomplete from 'google-autocomplete-vue';
// https://farmbook.com/API/listProvinces
export default {
  title: "FormSubUser",
  components: {
    mymodal,
    Loading,
    selectlocation,
  },
  props: ["pass_data"],
  computed: {
    priceFormat() {
      if (!this.item.price || this.item.price > this.max_price) {
        return "";
      } else {
        return new Intl.NumberFormat("en-US").format(this.item.price) + ' VND';
      }
    },
    getTitleText() {
      if (this.item && this.item.id) {
        return this.$t("Update news");
      } else {
        return this.$t("Add news");
      }
    },
    getOKText() {
      if (this.item.id) {
        return this.$t("Update");
      } else {
        return this.$t("Add");
      }
    },
  },
  data() {
    let dateFormat = "DD/MM/YYYY";
    return {
      uploadingPhoto: false,
      list_provinces: [],
      list_districts: [],
      list_communes: [],
      working: false,
      area: null,
      price: null,
      dateFormat: dateFormat,
      editPhotos: [],
      item: null,
      max_price:10000000000,
      list_types: [
        {
          id: 1,
          name: this.$t("Buy"),
        },
        {
          id: 2,
          name: this.$t("Sell"),
        },
        {
          id: 3,
          name: this.$t("Lease"),
        },
        {
          id: 4,
          name: this.$t("Cooperate"),
        },
      ],
      lease_id: 4,
    };
  },
  created() {
    // clone from original params
  },
  methods: {
    defaultValue() {
      return {
        title: "",
        province_id: "",
        district_id: "",
        commune_id: "",
        location: null,
        resource_electric: false,
        resource_water: false,
        resource_transport: false,
        type_id: null,
        description: "",
        status: 1,
        street_type: "0",
        certificate_type: "0",
        residental_area: null,
      };
    },
    triggerFile() {
      this.$refs.file.click();
    },
    handleFileUpload() {
      let file = this.$refs.file.files[0];

      if (file.size >= 524288) {
        return this.$alertify.alertWithTitle(
          this.$t("Confirm"),
          this.$t("Exceed maximum upload file size is 500kb")
        );
      }

      var validExtensions = ["jpg", "png", "jpeg"];
      var reader = new FileReader();

      reader.onloadend = (e) => {
        this.selectedFile = true;
        let arr = new Uint8Array(e.target.result).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }

        let mimeType = Utils.mimeType(header);
        if (mimeType === "unknown") {
          return this.$alertify.alertWithTitle(
            this.$t("Confirm"),
            this.$t("Only these file types are accepted") +
              " : " +
              validExtensions.join(", ")
          );
        }
        const blob = new Blob([e.target.result], {
          type: "image/png",
        });
        this.uploadPhoto(blob);
      };
      reader.readAsArrayBuffer(file);
    },
    uploadPhoto(blob) {
      this.uploadingPhoto = true;
      let formData = new FormData();
      formData.append("file", blob, "file.jpg");

      if (this.item.id) {
        formData.append("land_market_id", this.item.id);
      }
      let headers = {
        "Content-Type": "multipart/form-data",
      };
      Utils.request(this, true, "landmarket")
        .post("/imageLand/", formData, {
          headers: headers,
        })
        .then((response) => {
          console.log("response.data", response.data);
          this.editPhotos.push(response.data.data);
          this.uploadingPhoto = false;
          // if (this.job) {
          //   this.$emit('refreshPhotoList', this.editPhotos)
          //   this.updateJob()
          // }
        })
        .catch(() => {
          this.uploadingPhoto = false;
          this.$alertify.alertWithTitle(
            this.$t("Confirm"),
            this.$t("There was an issue when request, Please try again")
          );
        });
    },
    removePhoto(photo) {
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        this.$t("Are you sure to remove this photo ?"),
        () => {
          Utils.request(this, true, "landmarket")
            .delete(`/imageLand/${photo.id}`)
            .then((response) => {
              this.editPhotos = this.editPhotos.filter((item) => {
                return item.id != photo.id;
              });
            })
            .catch(() => {
              this.$alertify.alertWithTitle(
                this.$t("Confirm"),
                this.$t("There was an issue when request, Please try again")
              );
            });
        }
      );
    },
    open() {
      this.$refs.theModal.open();
      this.editPhotos = [];
      this.item = null;
      let item;
      if (this.pass_data) {
        item = JSON.parse(JSON.stringify(this.pass_data));
        item.resource_transport = item.resource_transport == "1";
        item.resource_electric = item.resource_electric == "1";
        item.resource_water = item.resource_water == "1";
        // console.log('item',item)

        if (item.lat) {
          item.location = [parseFloat(item.lat), parseFloat(item.lng)];
        }
      } else {
        item = this.defaultValue();
      }
      this.item = item;
      if (this.item.id) {
        this.getListPhotosFromLand();
      }
    },

    onSelectType() {
      console.log(this.item.type_id);
    },

    getListPhotosFromLand() {
      let data = {
        land_market_id: this.item.id,
      };

      Utils.request(this, true, "landmarket")
        .get(`/imageLand/?${Utils.arrayToRequestParam(data)}`)
        .then((response) => {
          this.editPhotos = response.data.data;
          console.log("this.editPhotos", this.editPhotos);
          //console.log('this.list_districts',this.list_districts)
        });
    },
    showStreet(value) {
      return Utils.getStreetType(value);
    },
    showCertificate(value) {
      return Utils.getCertificateType(value);
    },

    submitForm() {
      if (parseFloat(this.item.residental_area) > parseFloat(this.item.area)) {
        return this.$alertify.alertWithTitle(
          this.$t("Confirm"),
          this.$t("Residence area must be less than total area")
        );
      }

      let data = JSON.parse(JSON.stringify(this.item));

      let request;
      if (this.item.id) {
        // PUT request does not support validation
        request = Utils.request(this, true, "landmarket").put(
          `/manageLand/`,
          data
        );
      } else {
        if (this.editPhotos.length > 0) {
          data.image_ids = this.editPhotos.map((item) => {
            return item.id;
          });
        }
        request = Utils.request(this, true, "landmarket").post(
          `/manageLand/`,
          data
        );
      }

      request
        .then((response) => {
          let data = response.data;
          if (data.status === "ok") {
            this.$refs.theModal.close();
            this.$emit("modalData", {});
          } else {
            Utils.showError(this, this.$t(data.data));
          }
        })
        .catch((error) => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    updateLocation(data) {
      // console.log('data',data)
      for (let key in data) {
        this.item[key] = data[key];
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Land/FormLand.vue